import { Component } from '@angular/core';

@Component({
  selector: 'app-logged-in',
  templateUrl: './logged-in.component.html',
  styleUrls: ['./logged-in.component.scss'],
  standalone: false,
})
export class LoggedInComponent {
  constructor() {}
}
